import React, { useEffect } from 'react'
import { Buscador } from '../Buscador/Buscador'
import { ListadoRecursos } from '../List/List'
import { Footer } from '../Footer/Footer'
import { recursoService } from '../../aplicacion/addRecurso'
import '../../App.css'

export const Listado = () => {
  const [recursos, setRecursos] = React.useState([])
  const [recursosFiltrados, setRecursosFiltrados] = React.useState([])

  useEffect(() => {
    const fetchData = async () => {
      const a = await recursoService.getAll()
      setRecursos(a)
      setRecursosFiltrados(a)
    }
    fetchData()
  }, [])

  const onSearch = filtro =>
    setRecursosFiltrados(recursos.filter(recurso => recurso.nombre.toLowerCase().includes(filtro.toLowerCase())))

  const onTagSelected = filtro => {
    console.log(filtro)
    if (filtro === '') {
      setRecursosFiltrados(recursos)
    } else {
      setRecursosFiltrados(
        recursos.filter(recurso => {
          if (recurso.etiquetas) {
            return recurso.etiquetas.includes(filtro)
          }
          return false
        }),
      )
    }
  }

  const onDescSelected = filtro =>
    setRecursosFiltrados(
      recursos.filter(recurso => {
        if (recurso.destinatario) {
          return recurso.destinatario.toLowerCase().includes(filtro.toLowerCase())
        }
        return false
      }),
    )

  return (
    <header className="App-header">
      <Buscador onSearch={onSearch} onTagSelected={onTagSelected} onDescriptorSelected={onDescSelected} />
      <ListadoRecursos recursos={recursosFiltrados} />
      <Footer />
    </header>
  )
}
